<div class="row seedfullPage">
  <div class="seedEfulfillmentOuter">

    <div class="seedEfulfillment">
      <div class="order-view-sec breadcrumbOuter padding-0" id="orderView" [ngClass]="{
    'col-md-9':orderViewtoggle == false,
    'col-md-12':orderViewtoggle == true}">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item active">
              <a href="javascript:void(0)" (click)="navigateToReleaseLanding()">Plot Seed Release</a>
              <i class="fas fa-angle-right"></i>
            </li>
            <li class="breadcrumb-item" *ngIf="!isEditMode">
              <span>Create Release</span>
            </li>
            <li class="breadcrumb-item breadcrumbColor" aria-current="page" *ngIf="isEditMode">
              <span>{{releaseOrder.WebOrderNumber}}</span>
            </li>
          </ol>
        </nav>
      </div>
      <!--Crop year and filter section-->
      <div class="OrderReleaseTop">
        <div *ngIf="error">
          <div class="row">
            <div class="col-md-12">
              <div class="inline-error" *ngIf="error">
                <div class="row">
                  <div class="col-md-12 padding-l0">
                    <ol class="error-list">
                      <li class="justify-content-center align-self-center" *ngFor="let err of errorsList">
                        {{err}}
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--Ship to - Confirmation Email Section-->
        <div class="row justify-content-between">
          <div class="col-md-3 material-select withBordr pr-0 readOnly">
            <ng-select name="ddlProductLine"
                       [items]="productLineData"
                       class="custom-select-grower grower-add-drop"
                       [virtualScroll]="true"
                       bindLabel="value"
                       placeholder="Product Line"
                       bindValue="id"
                       (change)="getProductLineChange()"
                       (clear)="getProductLineChange()"
                       [(ngModel)]="releaseOrder.ProductLine"
                       [closeOnSelect]="true"
                       [disabled]="(isLandingOrder)">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-4">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.value}}
                      </h4>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
          </div>
          <div class="col-md-3 material-select withBordr p-0 readOnly">
            <ng-select name="ddlSalesManager"
                       [items]="salesManagerAccounts"
                       class="custom-select-grower grower-add-drop pb-0 associate-crop-select"
                       [(ngModel)]="releaseOrder.SalesManagerAccount"
                       [virtualScroll]="true"
                       [loading]="shipToDataLoading"
                       bindLabel="accountNameCityState"
                       placeholder="Sales Manager"
                       bindValue="accountNumber"
                       [disabled]="(isLandingOrder)"
                       [closeOnSelect]="true"
                       (change)=getSalesManagerChange($event)>
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-4">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.accountNumber}} - {{item.accountName}}
                      </h4>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
          </div>
          <div class="col-md-3 material-select withBordr readOnly">
            <ng-select name="ddlShipTo"
                       [items]="shipToData"
                       class="custom-select-grower grower-add-drop pb-0 associate-crop-select"
                       [virtualScroll]="true"
                       [(ngModel)]="releaseOrder.ShipToAccount"
                       bindLabel="accountNameCityState"
                       bindValue="accountNumber"
                       placeholder="Ship To:"
                       [loading]="shipToDataLoading"
                       [closeOnSelect]="true"
                       [disabled]="(isLandingOrder)"
                       [searchFn]="accountSearchFn"
                       (change)="getShipTo($event)"
                       (clear)="getShipTo($event)">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>

            </ng-select>
            <div class="shipTo">
              <div *ngIf="selectedDealer">
                <p>
                  Account#: {{selectedDealer.accountNumber}}
                </p>
                <p>
                  Address: {{selectedDealer.address1}},  {{selectedDealer.city}}, {{selectedDealer.state}} - {{selectedDealer.zipCode}}
                </p>
              </div>
            </div>           
          </div>
        </div>
        <div class="row">

        </div>
        <div class="row justify-content-between">
          <div class="col-md-3 material-select withBordr mt-3 pr-0 readOnly">
            <ng-select name="ddlOrderNumber"
                       [items]="webOrderNumberData"
                       class="custom-select-grower grower-add-drop"
                       [virtualScroll]="true"
                       bindLabel="value"
                       placeholder="Plot Seed Order Number"
                       bindValue="id"
                       (change)="getOrderNumberChange($event)"
                       (clear)="getOrderNumberChange($event)"
                       [(ngModel)]="releaseOrder.OrderHeaderId"
                       [closeOnSelect]="true"
                       [disabled]="(isLandingOrder)">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-4">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.value}}
                      </h4>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
          </div>
          <div class="col-md-3 material-select nonRequired withBordr p-0 readOnly">
            <ng-select name="ddlDeliverTo"
                       [items]="deliverToData"
                       class="custom-select-grower grower-add-drop pb-0 associate-crop-select"
                       [virtualScroll]="true"
                       [(ngModel)]="releaseOrder.DeliverTo"
                       bindLabel="accountNameCityState"
                       bindValue="accountNumber"
                       placeholder="Deliver To:"
                       [loading]="deliverToLoading"
                       [closeOnSelect]="true"
                       [searchFn]="accountSearchFn"
                       [disabled]="isReleased || accessTypeMode || !releaseOrder.DeliverToAnotherLocation || disableDeliverTo"
                       (change)="getDeliverToAccount($event)">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
            <div class="shipTo">
              <div *ngIf="deliverTo">
                <p>
                  Account#: {{deliverTo.accountNumber}}
                </p>
                <p>
                  Address: {{deliverTo.address1}},  {{deliverTo.city}}, {{deliverTo.state}} - {{deliverTo.zipCode}}
                </p>
              </div>
            </div>
            <div class="checkbox-color checkbox-alignment">
              <mat-checkbox class="custom-checkbox p-0"
                            [disabled]="isReleased || accessTypeMode || disableDeliverTo"
                            [style.display]=""
                            [indeterminate]=""
                            (change)="removeDeliverTo()"
                            [(ngModel)]="releaseOrder.DeliverToAnotherLocation"
                            data-testid="ddl-deliver-to-checkbox">I want this delivered to another location.</mat-checkbox>
            </div>
          </div>
          <div class="col-md-3 deliveryNotes material-select d-flex justify-content-start p-0">
            <mat-form-field class="wide100 col-md-11">
              <mat-label>Delivery Instructions:</mat-label>
              <input matInput type="text" name="deliveryInstructionsCodes" class="pb-1" data-testid="btn-delivery-instructions-codes"
                     [(ngModel)]="releaseOrder.DeliveryInstructionsCodes"
                     [readonly]="isReleased || accessTypeMode"
                     [disabled]="(isReleased || accessTypeMode)"
                     [maxLength]="50"
                     autocomplete="off">
            </mat-form-field>
          </div>
        </div>
        <div class="row justify-content-between">
          <div class="col-md-3 material-select withBordr mt-3 pr-0 readOnly">
            <ng-select name="ddlBranch"
                       [items]="branchPlantData"
                       class="custom-select-grower grower-add-drop"
                       [virtualScroll]="true"
                       [(ngModel)]="releaseOrder.BranchPlant"
                       bindLabel="description"
                       placeholder="Branch Plant"
                       [loading]="branchDataLoading"
                       bindValue="id"
                       [closeOnSelect]="true"
                       [disabled]="true">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.description}}
                      </h4>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
          </div>
          <div class="col-md-3 customerPO p-0">
            <mat-form-field class="wide100">
              <mat-label>Customer PO:</mat-label>
              <input matInput type="text" name="customerPO" class="pb-1"
                     [(ngModel)]="releaseOrder.CustomerPO"
                     [readonly]="isReleased || accessTypeMode"
                     [maxLength]="25">
            </mat-form-field>
          </div>

          <div class="col-md-3 material-select withBordr readOnly">
            <ng-select name="ddlFreighthandlingCodeDetails"
                       [items]="freightHandlingCodeData"
                       class="custom-select-grower grower-add-drop"
                       [(ngModel)]="releaseOrder.FreightHandlingCode"
                       [virtualScroll]="true"
                       bindLabel="value"
                       placeholder="Freight Handling Code"
                       [loading]="freightHandlingCodeDataLoading"
                       bindValue="id"
                       [closeOnSelect]="true"
                       [disabled]="releaseOrder.IsCustomerPickup"
                       [clearable]="false"
                       (change)="OnFreighthandlingCodeChange($event)">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-4">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.value}}
                      </h4>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
          </div>

        </div>
        <div class="row justify-content-between align-items-center">
          <div class="col-md-3">

            <mat-form-field>
              <mat-label>Requested Date</mat-label>
              <input matInput [readonly]="true" [matDatepicker]="picker" (dateChange)="validateDate($event)" [(ngModel)]="releaseOrder.RequestedDate" placeholder="Requested Date" (focus)="picker.open();" [min]="minDate" [max]="maxDate" [matDatepickerFilter]="dateFilter">
              <mat-datepicker-toggle matSuffix [for]="picker" [disabled]="isReleased || accessTypeMode"></mat-datepicker-toggle>
              <mat-datepicker #picker [disabled]="isReleased || accessTypeMode"></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-md-3 checkbox-color d-flex align-items-center p-0">
            Customer Pickup:  <mat-checkbox #CustomerPickupCheck class="custom-checkbox margin-l10"
                                            [style.display]=""
                                            [indeterminate]=""
                                            [(ngModel)]="releaseOrder.IsCustomerPickup"
                                            [disabled]="(isReleased || accessTypeMode)"
                                            matTooltip="Select For Customer Pickup" [matTooltipPosition]="'above'"
                                            data-testid="ddl-customer-pickup"
                                            (change)="setFreightHandlingCode()"></mat-checkbox>
          </div>
          <div class="col-md-3 d-flex align-items-center justify-content-center">
            <div class="customerPO">
              <button mat-raised-button class="btns createReleaseBtns" [disabled]="isValidOrder" (click)="computeInventory()" data-testid="btn-compute-inventory2">Compute Inventory</button>
            </div>
          </div>
        </div>

      </div>

      <div class="OrderReleaseDetail">
        <!--Product Detail section-->
        <div class="form-sec">

          <div class="row margin-r0 margin-b20">
            <div class="col-md-11 product-filter-outer">
              <div class="product-filter-outer">
                <div class="product-filter col-md-12">
                  <div class="search-category">
                    <div class="brand-dropdown default-select agent-crop-select">
                      <ng-select [items]="searchTypeList"
                                 name="ddlProductSearch"
                                 [(ngModel)]="productSearchFilter"
                                 [virtualScroll]="true"
                                 [closeOnSelect]="true"
                                 [selectOnTab]="true"
                                 [clearable]="false"
                                 bindLabel="name"
                                 bindValue="value"
                                 [searchable]="false"
                                 (change)="keepFilter()"
                                 placeholder="Select Category">
                      </ng-select>
                    </div>
                  </div>
                  <div class="search-box">
                    <div class="row margin-0">
                      <div class="default-select select-container">
                        <div *ngIf="productSearchFilter === 'Variety'">
                          <div class="searchInputBox">
                            <span class="search-icon">
                              <i class="fas fa-search"></i>
                            </span>
                            <div class="select-container">
                              <input class="custom-select-grower"
                                     [(ngModel)]="productFilters.Variety"
                                     placeholder="Search..." (keyup.enter)="enableSearchButton && onSearchClick()">
                            </div>
                          </div>
                        </div>
                        <div class="agent-crop-select d-flex gap-3">
                          <!-- Maturity From (Min) Dropdown -->
                          <div class="flex-fill" *ngIf="productSearchFilter === 'Maturity'">
                            <ng-select #maturityFromSearch
                                       name="ddlMaturityFrom"
                                       [items]="availableMaturityOptions"
                                       placeholder="Min"
                                       class="custom-select-grower"
                                       [(ngModel)]="productFilters.MaturityFrom"
                                       [virtualScroll]="true"
                                       bindLabel="value"
                                       bindValue="id"
                                       [clearable]="true"
                                       [searchable]="true"
                                       (change)="keepFilter();onMaturityFromChange()">
                              <ng-template ng-option-tmp let-item="item">
                                <div class="dropdown-template">
                                  <p class="name">{{item.value}}</p>
                                </div>
                              </ng-template>
                              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                                <div class="ng-option disabled">
                                  No data found for "{{searchTerm}}"
                                </div>
                              </ng-template>
                            </ng-select>
                          </div>

                          <!-- Maturity To (Max) Dropdown -->
                          <div class="flex-fill" *ngIf="productSearchFilter === 'Maturity'">
                            <ng-select #maturityToSearch
                                       name="ddlMaturityTo"
                                       [items]="availableMaturityOptions"
                                       placeholder="Max"
                                       class="custom-select-grower"
                                       [(ngModel)]="productFilters.MaturityTo"
                                       [virtualScroll]="true"
                                       bindLabel="value"
                                       bindValue="id"
                                       [clearable]="true"
                                       [searchable]="true"
                                       (change)="keepFilter();onMaturityToChange()">
                              <ng-template ng-option-tmp let-item="item">
                                <div class="dropdown-template">
                                  <p class="name">{{item.value}}</p>
                                </div>
                              </ng-template>
                              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                                <div class="ng-option disabled">
                                  No data found for "{{searchTerm}}"
                                </div>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
                <div class="row chips-sec" *ngIf="filterValueList != '' ">
                  <div class="col-sm-9 col-md-10 selected-chip">
                    <mat-chip-set>
                      <mat-chip selected *ngFor="let filterValue of filterValueList">
                        {{filterValue}}
                        <a href="Javascript:void(0);" (click)="clearFilter(filterValue)">
                          <i class="fas fa-times text-right"></i>
                        </a>
                      </mat-chip>
                    </mat-chip-set>
                  </div>
                  <div class="col-sm-3 col-md-2 text-right">
                    <a href="Javascript:void(0);" class="clearAll" (click)="clearAllFilter()">Clear All</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-1">
              <button mat-raised-button (click)="onSearchClick()" class="btns">Search</button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 productTableOuter">
            <div class="tableContainer">
              <table mat-table [dataSource]="orderReleaseDS" multiTemplateDataRows class="matTables productTable">
                <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
                  <div *ngIf="column=='marketingBrand'"><th mat-header-cell *matHeaderCellDef class="text-center">Marketing Brand</th>
            </div>
            <div *ngIf="column=='variety'"><th mat-header-cell *matHeaderCellDef class="text-center">Hybrid Variety</th></div>
            <div *ngIf="column=='maturity'"><th mat-header-cell *matHeaderCellDef class="text-center">Maturity</th></div>
            <div *ngIf="column=='itemNumber'"><th mat-header-cell *matHeaderCellDef class="text-center">Item Number</th></div>
            <div *ngIf="column=='itemDescription'"><th mat-header-cell *matHeaderCellDef class="text-center">Item Description</th></div>
            <div *ngIf="column=='orderQty'"><th mat-header-cell *matHeaderCellDef class="availableToRelease text-center">Order Qty</th></div>
            <div *ngIf="column=='remainingQty'"><th mat-header-cell *matHeaderCellDef class="availableToRelease text-center">Remaining Qty</th></div>
            <div *ngIf="column=='availableQty'"><th mat-header-cell *matHeaderCellDef class="hard-soft-release text-center">Available Qty</th></div>
            <div *ngIf="column=='releaseQty'"><th mat-header-cell *matHeaderCellDef class="text-center releaseQuantity">Release Qty</th></div>
            <div *ngIf="column=='uom'"><th mat-header-cell *matHeaderCellDef class="text-center">UOM</th></div>
            <div [ngStyle]="column=='iconsDisplay' ? {visibility: visible} : {visibility: hiden}"><th mat-header-cell *matHeaderCellDef class="text-left icon-display padding-l0"></th></div>

            <td mat-cell *matCellDef="let element">

              <div *ngIf="column=='marketingBrand'" class="text-center">
                <div>
                  <p class="mb-0">{{element.marketingBrand}}</p>
                </div>
              </div>
              <div *ngIf="column=='variety'" class="text-center">
                <div>
                  <p class="mb-0">{{element.brand}}</p>
                </div>
              </div>
              <div *ngIf="column=='maturity'" class="available-block text-center">
                <div>
                  <span> {{element.maturity}}</span>
                </div>
              </div>
              <div *ngIf="column=='itemNumber'" class="available-block text-center">
                <div>
                  <span> {{element.itemNumber}}</span>
                </div>
              </div>
              <div *ngIf="column=='itemDescription'" class="available-block text-center">
                <div>
                  <span> {{element.itemDescription}}</span>
                </div>
              </div>
              <!--<div *ngIf="column=='totalOrderUnits'" class="available-block text-center">
   <div>
     <span class="seed-avail" *ngIf="element.dealerUnits>=0">{{element.dealerUnits | number}}</span>
     <span class="seed-avail" *ngIf="element.dealerUnits<0">({{element.dealerUnits | positiveValue | number}})</span>
   </div>
  </div>-->
              <div *ngIf="column=='orderQty'" class="text-center">
                <span>
                  {{element.orderQty | number}}
                </span>
              </div>
              <div *ngIf="column=='remainingQty'" class="text-center">
                <div>
                  <span>
                    {{ element.remainingQty < 0 ? 0 : (element.remainingQty | number) }}
                  </span>
                </div>
              </div>
              <div *ngIf="column=='availableQty'" class="text-center">
                <div *ngIf="isInventoryComputed">
                  <span> {{element.availableQty | number}}</span>
                </div>
              </div>
              <div *ngIf="column=='releaseQty'" class="text-center">
                <div *ngIf="element.remainingQty > 0 && isInventoryComputed && element.active">
                  <button (click)="dealerUnitChange('decrease',element);element.isSelected=true" class="plus-minus-btn minusBtn" *ngIf="!isReleased && !accessTypeMode && element.remainingQty > 0 && element.active"> - </button>
                  <!--<input type="text" class="geu-txt padding-t2" [(ngModel)]="element.releaseQty" [readonly]="isReleased || accessTypeMode" maxlength="5" NumbersOnly />-->
                  <input type="text" class="geu-txt padding-t2" [(ngModel)]="element.releaseQty" [readonly]="isReleased || accessTypeMode || element.remainingQty <= 0 || !element.active" (focusout)="validateLineItem(element,'releaseUnit')" maxlength="5" NumbersOnly />
                  <button (click)="dealerUnitChange('increase',element); element.isSelected=true" class="plus-minus-btn plusBtn" *ngIf="!isReleased && !accessTypeMode && element.remainingQty > 0 && element.active"> + </button>
                </div>
              </div>
              <div *ngIf="column=='uom'" class="text-center">
                <div>
                  <span> {{element.uom}}</span>
                </div>
              </div>
              <div *ngIf="column=='iconsDisplay' && element.releaseQty > 0" style="margin-left: -40px;">
                <button mat-button [matMenuTriggerFor]="beforeMenu1" class="context-menu">
                  <i class="fas fa-ellipsis-v blue-color"></i>
                </button>
                <mat-menu #beforeMenu1="matMenu" xPosition="before" class="context-meun-dropdown">
                  <button mat-menu-item (click)="openPlotReleaseBreakdown(element, 'V')" data-testid="btn-view-lots">View Lots</button>
                  <!--<button mat-menu-item (click)="openSeedFulfillmentBreakdown(element, 'E')" [disabled]="element.isBulk != 'Y'" data-testid="btn-edit-lots">Edit Lots</button>-->
                </mat-menu>
              </div>
            </td>
            </ng-container>

            <ng-container matColumnDef="expandedDetail">
              <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                <div class="inline-error" *ngIf="element.lineErrors.errors.length > 0" id="error_{{element.lineErrors.rowId}}">
                  <div class="row">
                    <div class="col-md-9">
                      <ol class="error-list">
                        <li *ngFor="let err of element.lineErrors.errors">
                          {{err.error}}
                      </ol>
                    </div>
                    <div class="col-md-3 revertToPrev" (click)="revertToPreviousError(element, true)">
                      <span>
                        Revert to Previous.
                        <i class="icon-ico-Reply"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
            <tr mat-row *matRowDef="let element; columns: displayedColumns;"
                class="example-element-row"
                [class.example-expanded-row]="expandedElement === element"
                (click)="expandedElement = expandedElement === element ? null : element"></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!--Requested Pallettes section-->
    <div class="OrderReleaseDetail padding-t0">
      <div class="requestPallet margin-t30 col-12">
        <div class="row">
          <div class="col-4" *ngIf="!isPalletSectionShow"></div>
          <div class="col-5" *ngIf="isPalletSectionShow">
            <div class="row margin-b10">
              <div class="col-md-5 padding-l0 padding-r0">
                <h6>Requested Pallets and Charges</h6>
              </div>
              <div class="showChangesSection col-md-4 padding-r0 padding-t2" [ngStyle]="{'pointer-events':accessTypeMode ? 'none':'auto'}">
                <div class="toggleColor">
                  <span class="padding-r10" style="color: #004E7A;">OVERRIDE: <b style="color: #004E7A;"> {{isOverride?"ON":"OFF"}}</b> </span>
                  <label class="switch">
                    <input type="checkbox" checked>
                    <span class="slider round" (click)="toggleOverrideOnly()" checked="false"></span>
                  </label>
                </div>
              </div>
              <div class="col-md-3 padding-r0 text-right">
                <button type="button" mat-raised-button class="btns" color="primary" (click)="addPalletType()" [disabled]="!isOverride" data-testid="btn-add-pallets">Add Pallets</button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 padding-l0 padding-r0">
                <div class="requestPalletTable">
                  <table class="matTables mat-table" style="border-bottom: none; border-left: none;">
                    <thead>
                      <tr class="mat-header-row">
                        <th class="mat-header-cell type brdrRight borderLeft">
                          Type
                        </th>
                        <th class="mat-header-cell text-center brdrRight bgGray">
                          Quantity
                        </th>
                        <th class="mat-header-cell text-center bgGray" *ngIf="!isReleased || accessTypeMode">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="mat-row" *ngFor="let arrayitem of palletArrayItems;let i=index">
                        <td class="mat-cell brdrRight borderLeft">
                          <div class="material-select requestPalletSelect withBordr">
                            <ng-select *ngIf="arrayitem['palletType']==''" name="ddlPalletType"
                                       [items]="palletTypeData"
                                       class="custom-select-grower grower-add-drop"
                                       [virtualScroll]="true"
                                       [(ngModel)]="arrayitem['itemId']"
                                       bindLabel="value"
                                       placeholder="Pallet Type:"
                                       [loading]="palletTypeLoading"
                                       bindValue="id"
                                       [closeOnSelect]="true"
                                       [disabled]="isReleased || accessTypeMode || !this.isOverride"
                                       (clear)="arrayitem['palletQuantity']=0"
                                       (change)="setPalletItem($event, arrayitem['rowId'], arrayitem['palletQuantity'])">
                              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                <div class="dropdown-template">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h4 class="name" [ngOptionHighlight]="search">
                                        {{item.value}}
                                      </h4>
                                    </div>
                                  </div>
                                </div>
                              </ng-template>
                            </ng-select>
                            <span *ngIf="arrayitem['palletType']!=''" style="color: #004E7A;">{{arrayitem['palletType']}}</span>
                          </div>
                        </td>
                        <td [ngClass]="isReleased == true ? 'mat-cell text-center brdrRight' : 'mat-cell text-right brdrRight'">
                          <mat-form-field style="width: 80px; text-align: center !important;" [appearance]="isReleased || accessTypeMode || !this.isOverride ? 'none':'legacy'">
                            <input matInput type="text" class="geu-txt" [(ngModel)]="arrayitem['palletQuantity']" (keyup)="palletQuantityChange(arrayitem['rowId'], arrayitem['palletQuantity'])"
                                   [readonly]="isReleased || accessTypeMode || !this.isOverride" maxlength="5" NumbersOnly>
                          </mat-form-field>
                        </td>
                        <td class="mat-cell text-center" *ngIf="!isReleased || accessTypeMode">
                          <div class="delete-button" *ngIf="this.isOverride">
                            <span (click)="removePalletItem(i)" matTooltip="Delete" [matTooltipPosition]="'above'">
                              <i class="icon-ico-trash"></i>
                            </span>
                          </div>
                        </td>
                      </tr>
                      <tr *ngIf="palletArrayItems.length == 0">
                        <td colspan="3" class="mat-cell text-center borderLeft borderBottom" style="color: #004E7A; padding-top: 12px; padding-bottom: 12px; border-bottom: 1px solid #e5e1dc;">
                          No Pallets added to request
                        </td>
                      </tr>
                      <tr class="mat-row" *ngIf="palletArrayItems.length == 0">
                        <td [ngClass]="palletArrayItems.length == 0 ? 'noBorder':''" class="mat-cell text-right brdrRight bgGray padding-r0" style="padding-top: 12px; padding-bottom: 12px;">
                          <span style="background: #ECE8E5; padding: 16px 24px; color: #004E7A; ">Pallet Count:</span>
                        </td>
                        <td class="mat-cell text-right brdrRight">
                        </td>
                        <td class="mat-cell text-right brdrRight">
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="col-1" *ngIf="isPalletSectionShow"></div>
          <div class="col-3">
            <div class="row margin-b10">
              <div class="padding-l0">
                <h6>Shipment Weight Computation</h6>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 padding-l0 padding-r0">
                <div class="requestPalletTable">
                  <table class="matTables mat-table">
                    <tr class="mat-header-row">
                      <th class="mat-header-cell type brdrRight">
                        Seed Weight
                      </th>
                      <th class="mat-header-cell text-right brdrRight ">
                        {{totalSeedWeight}}
                      </th>
                      <th class="mat-header-cell text-center">
                        Pounds
                      </th>
                    </tr>
                    <tr class="mat-header-row" *ngIf="isPalletSectionShow">
                      <th class="mat-header-cell type brdrRight">
                        Pallet Weight
                      </th>
                      <th class="mat-header-cell text-right brdrRight ">
                        {{totalPalletWeight}}
                      </th>
                      <th class="mat-header-cell text-center">
                        Pounds
                      </th>
                    </tr>
                    <tr class="mat-header-row">
                      <th class="mat-header-cell type brdrRight">
                        Total Weight
                      </th>
                      <th class="mat-header-cell text-right brdrRight ">
                        {{totalComputedWeight}}
                      </th>
                      <th class="mat-header-cell text-center">
                        Pounds
                      </th>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="col-2"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="common-error-block" *ngIf="showErrorBlock && errorMsgs.length>0 && errorMsgs[index].errors.length > 0">
    <div class="row">
      <div class="col-md-2 padding-r0 errCountOuter">
        <!--<span class="close-icon">
          <i class="icon-ico-Error"></i>
        </span>-->
        <span class="errorCounting">
          {{currentErrorRow}} of {{errorMsgs.length}}
        </span>
      </div>
      <div class="col-md-6 padding-l0 ">
        <ul class="errorMsg">
          <li *ngFor="let err of errorMsgs[index].errors">
            <p> {{err.error}}</p>
          </li>
        </ul>
      </div>
      <div class="col-md-4 button-sec text-right">
        <button mat-raised-button class="btns" color="primary" (click)="revertAllChanges()" data-testid="btn-revert-errors">Revert All Errors</button>
        <button mat-raised-button class="btns" color="primary" *ngIf="errorMsgs && errorMsgs.length>0" (click)="nextError()" data-testid="btn-next-error">Next Error</button>
      </div>
    </div>
  </div>
  <div class="SeedFulfillBtnSec">
    <div class="row">
      <div class="col-md-12">
        <button mat-raised-button class="btns" [disabled]="!canSaveData || !canSaveAndReleaseOrder"  (click)="placeJdeOrder()" data-testid="btn-place-erp-order">Place ERP Order</button>
        <!--<button mat-raised-button class="btns" [disabled]="!canSaveData || !canSaveAndReleaseOrder" *ngIf="!isReleased && !accessTypeMode" (click)="placeJdeOrder()" data-testid="btn-place-erp-order">Place ERP Order</button>-->
        <button mat-raised-button class="btns" color="primary" [disabled]="isComputeDisabled" *ngIf="!isReleased && !accessTypeMode" (click)="computePalletAndSeedWeight()" data-testid="btn-compute-pallets">Compute Pallets and Weight</button>
        <button mat-raised-button class="btns" color="primary" (click)="navigateToReleaseLanding()" data-testid="btn-seed-fulfillment-cancel">Cancel</button>
      </div>
    </div>
  </div>
</div>
</div>
